/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Organization } from './Organization';
// @ts-ignore
import {
// @ts-ignore
    OrganizationFromJSON,
// @ts-ignore
    OrganizationFromJSONTyped,
// @ts-ignore
    OrganizationToJSON,
} from './Organization';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface Retailer
 */
export interface Retailer {
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    currencyCode: string;
    /**
     * 
     * @type {Status}
     * @memberof Retailer
     */
    status: Status;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    customerCode?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Retailer
     */
    organization?: Organization;
    /**
     * 
     * @type {Date}
     * @memberof Retailer
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the Retailer interface.
 */
// @ts-ignore
export function instanceOfRetailer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

// @ts-ignore
export function RetailerFromJSON(json: any): Retailer {
    return RetailerFromJSONTyped(json, false);
}

// @ts-ignore
export function RetailerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Retailer {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organization_id'],
        'name': json['name'],
        'email': json['email'],
        'currencyCode': json['currency_code'],
        'status': StatusFromJSON(json['status']),
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'customerCode': !exists(json, 'customer_code') ? undefined : json['customer_code'],
        'organization': !exists(json, 'organization') ? undefined : OrganizationFromJSON(json['organization']),
        'createdAt': (new Date(json['created_at'])),
    };
}

// @ts-ignore
export function RetailerToJSON(value?: Retailer | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organizationId,
        'name': value.name,
        'email': value.email,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'external_code': value.externalCode,
        'customer_code': value.customerCode,
        'organization': OrganizationToJSON(value.organization),
        'created_at': (value.createdAt.toISOString()),
    };
}

